/**
 * 8社ロール情報
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 8社ロール情報DTO
 */
export interface CompanyGroupDto { 
    /**
     * 会社グループコード
     */
    companyGroupCode?: string;
    /**
     * 会社コードリスト
     */
    companyCodeList?: string[];
}

